<template>
    <a
        v-if="href"
        :href="href"
        :class="buttonClasses"
        v-bind="$attrs"
        :disabled="disabled"
        @click="onClick"
    >
        <slot name="icon"></slot>
        <slot />
    </a>
    <component
        :is="element"
        v-else
        :class="buttonClasses"
        v-bind="$attrs"
        :disabled="disabled"
        @click="onClick"
    >
        <span class="flex justify-center items-center" :style="{ color: loading ? 'transparent' : 'inherit' }">
            <slot name="icon"></slot>
            <slot />
        </span>
        <div v-if="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
            <LoadingIcon width="24" />
        </div>
    </component>
</template>

<script setup>
import { ref, computed } from 'vue';
import LoadingIcon from '@/assets/icons/Loading.vue';

const props = defineProps({
    href: {
        type: String,
        default: ''
    },
    to: {
        type: String,
        default: ''
    },
    preventDefault: {
        type: Boolean,
        default: false
    },
    variation: {
        type: String,
        default: 'primary'
    },
    size: {
        type: String,
        default: 'normal'
    },
    loading: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    element: {
        type: String,
        default: 'button'
    }
});

const emit = defineEmits(['click']);

const buttonClasses = computed(() => {
    return [
        'relative btn',
        { 'btn-primary': props.variation === 'primary' },
        { 'btn-secondary': props.variation === 'secondary' },
        { 'btn-link': props.variation === 'link' },
        { 'btn-sm': props.size === 'small' },
        { 'btn-lg': props.size === 'large' }
    ]
})

const onClick = (e) => {
    const preventDefault = ref(props.preventDefault);
    const loading = ref(props.loading);

    if(loading.value) return;

    emit('click', e);
    if (preventDefault.value) {
        e.preventDefault();
    }
}
</script>